import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-phone\">\r\n  <path d=\"M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm3.445,17.827c-3.684,1.684-9.4-9.43-5.8-11.308L10.7,6l1.746,3.409L11.4,9.922c-1.1.587,1.185,5.04,2.305,4.5l1.032-.505,1.76,3.4-1.054.516Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol